import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function Retailer(props) {
  const appText = useI18n();
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    _loadPackageTypes();
  }, []);

  async function _loadPackageTypes() {
    await NuxeoClient.instance()
      .fetchPackageTypes()
      .then((response) => {
        setFetchedData(response);
        setIsLoading(false);
      });
  }

  const handleChange = (values) => {
    if (values === null) {
      props.handleChange("packageType", []);
    } else {
      let result = values.map((value) => value.label);
      props.handleChange("packageType", result);
    }
  };

  return (
    // <Tooltip arrow title="Please enter the package type for this package">
    <Tooltip arrow title={appText.T222}>
      <Grid item={true} xs={12}>
        <div id="consumerTarget">
          <InputLabel className="field-label field-dropdown">
            {/* Package Type */}
            {appText.T179}
          </InputLabel>
          <Autocomplete
            type={"multi"}
            handleChange={handleChange}
            data={fetchedData}
            dataType={"packageType"}
            mapVariable={"label"}
            setFilterData={() => null}
            value={props.value}
            isLoading={isLoading}
          />
          {/* <small>
            <i>
              If you cannot find the package type you are looking for, you may
              manually enter it in the "Notes for BA Representative" field
              below.
            </i>
          </small> */}
          <small>
            <i>{appText.T180}</i>
          </small>
        </div>
      </Grid>
    </Tooltip>
  );
}
